module.exports = __webpack_public_path__ + "4ca67b9b0969ae18bb4ac4bc4a2bd9e6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/background_sounds/forest.png
// module id = 3156
// module chunks = 0